import { POLAROID_DEFAULTS } from '@shared/core/website/headerMotion/headerMotion.catalog';
import type { HeaderMotionOptions } from '@shared/core/website/headerMotion/headerMotion.types';

import { motionNamesColor, motionNavColor } from '../../multiPhotoMotion.options';

/**
 * Sanitises saved Polaroid options: the catalog's `POLAROID_DEFAULTS`, plus `namesColor` and `navColor`
 * where the saved ones are plain hex colours (see `motionNamesColor`). Every other key is dropped. Pure;
 * never throws.
 */
export const parsePolaroidOptions = (raw: Readonly<Record<string, unknown>>): HeaderMotionOptions => {
  const namesColor = motionNamesColor(raw);
  const navColor = motionNavColor(raw);
  return { ...POLAROID_DEFAULTS, ...(namesColor ? { namesColor } : {}), ...(navColor ? { navColor } : {}) };
};
